export const PARTNERS = {
  CARMAX: 'kmx',
  CARWISER: 'carwiser',
  CASHFORCARS: 'cashforcars',
  ECHOPARK: 'echopark',
  ICO: 'ico',
  ICOMODULE: 'icomodule',
  PLUG: 'plug',
};
